// src/screens/DashboardRedirect.js
// ─────────────────────────────────────────────────────────────────────────────
// The Google OAuth backend redirects to /dashboard after successful login.
// This component mounts at that route, reads any tokens from query params,
// saves them, then immediately sends the user to /dm-activity.
// ─────────────────────────────────────────────────────────────────────────────

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const DashboardRedirect = () => {
  const navigate      = useNavigate();
  const { login }     = useAuth();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const accessToken  = params.get('access_token')  || params.get('token');
    const refreshToken = params.get('refresh_token');
    const userId       = params.get('user_id')        || params.get('id');
    const role         = params.get('role')            || '';
    const userEmail    = params.get('email')           || params.get('user_email') || '';

    if (accessToken) {
      // Save tokens
      localStorage.setItem('access_token',  accessToken);
      if (refreshToken) localStorage.setItem('refresh_token', refreshToken);
      localStorage.setItem('user_id',    userId    || '');
      localStorage.setItem('role',       role);
      localStorage.setItem('user_email', userEmail);

      // Update auth context
      login(
        { access_token: accessToken, refresh_token: refreshToken, user_id: userId, role },
        userEmail
      );
    }

    // Whether or not tokens were in the URL, always go to /dm-activity.
    // If the user already has a valid token (stored from before), they'll
    // land on the right page. If not, the protected route will redirect to login.
    setReady(true);
    navigate('/dm-activity', { replace: true });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0a0b14',
      gap: '1rem',
    }}>
      <Loader2
        size={32}
        style={{ color: '#6366F1', animation: 'spin 0.8s linear infinite' }}
      />
      <p style={{ color: '#9CA3AF', fontSize: '0.85rem', fontWeight: 500 }}>
        Redirecting…
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default DashboardRedirect;